import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../services/filtering/filter-form-render-service';
import messages from '../messages';
import { dateFilterOperators } from '../../../containers/base-filter-bar-container/reference-data-criteria-arguments';

export default {
  id: 'modifyDateUTC',
  displayName: <FormattedMessage {...messages.modifyDateUTCColumnHeader} />,
  type: OptionFormTypes.TYPE_ORDER_DATE_COMPARISON,
  filterValue: 'ModifyDate',
  render: (criteriaInformations) => {
    const criterionOperatorOptions = [
      {
        id: dateFilterOperators.neverModified,
        advanced: true,
        displayName: <FormattedMessage {...messages.neverModified} />,
        value: dateFilterOperators.neverModified,
      },
      ...criteriaInformations.criterionOperatorOptions,
    ];
    const criteriaWithNeverModified = {
      ...criteriaInformations,
      criterionOperatorOptions,
    };
    return renderFormBasedOnType(OptionFormTypes.TYPE_ORDER_DATE_COMPARISON, criteriaWithNeverModified);
  },
};
